import { ListNode as BaseListNode } from "@lexical/list";
import { EditorConfig } from "lexical";

export class CustomListNode extends BaseListNode {
  __numberType: string;

  constructor(tag: any, key?: any, numberType: string = "number") {
    super(tag, key);
    this.__numberType = numberType;
  }

  static getType(): string {
    return "custom-list";
  }

  static clone(node: CustomListNode): CustomListNode {
    // Pass the original node's __key to the new instance
    return new CustomListNode(node.__tag, node.__key, node.__numberType);
  }

  createDOM(config: EditorConfig): HTMLElement {
    const dom = super.createDOM(config);
    dom.style.listStyleType = this.__numberType; // Apply custom styles
    return dom;
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      numberType: this.__numberType, // Serialize the numberType
    };
  }

  static importJSON(serializedNode: any): CustomListNode {
    const node = super.importJSON(serializedNode) as CustomListNode;
    node.__numberType = serializedNode.numberType || "number";
    return node;
  }
}
